import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Imprint from "./pages/Imprint";
import Privacy from "./pages/Privacy";
import Services from "./pages/Services";
import About from "./pages/About";
import KnowledgeCenter from "./pages/KnowledgeCenter";
import AIUseCases from "./pages/AIUseCases";
import SpinOffs from "./pages/SpinOffs";
import Produkte from "./pages/Produkte";
import Granalis from "./pages/Granalis";
import KIBeratung from "./pages/KIBeratung";
import KITransformation from "./pages/KITransformation";
import KICoaching from "./pages/KICoaching";
import KIWorkshops from "./pages/KIWorkshops";
import KIAnwendungen from "./pages/KIAnwendungen";
import KIPlattform from "./pages/KIPlattform";
import KIMVPDevelopment from "./pages/KIMVPDevelopment";
import KILab from "./pages/KILab";
import PrivateEquityWhitepaper from "./pages/PrivateEquityWhitepaper";
import KIOrganisationWhitepaper from "./pages/KIOrganisationWhitepaper";
import PartnerProgramm from "./pages/PartnerProgramm";
import KIValueCheck from "./pages/KIValueCheck";
import KIValueEngine from "./pages/KIValueEngine";
import ValueDashboard from "./pages/ValueDashboard";
import SouveraneCloud from "./pages/SouveraneCloud";
import ROIBusinessImpact from "./pages/ROIBusinessImpact";
import PrivateEquity from "./pages/PrivateEquity";
import AIWizzPlatform from "./pages/AIWizzPlatform";
import AIDrivenEnterprise from "./pages/AIDrivenEnterprise";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsentManager from "./components/CookieConsentManager";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/leistungsangebot" element={<Services />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/wissenscenter" element={<KnowledgeCenter />} />
            <Route path="/ki-fallstudien" element={<AIUseCases />} />
            <Route path="/spin-offs" element={<SpinOffs />} />
            <Route path="/produkte" element={<Produkte />} />
            <Route path="/granalis" element={<Granalis />} />
            <Route path="/leistungsangebot/ki-akademie" element={<KIBeratung />} />
            <Route path="/leistungsangebot/ki-transformation" element={<KITransformation />} />
            <Route path="/leistungsangebot/ki-coaching" element={<KICoaching />} />
            <Route path="/leistungsangebot/ki-workshops" element={<KIWorkshops />} />
            <Route path="/leistungsangebot/ki-anwendungen" element={<KIAnwendungen />} />
            <Route path="/leistungsangebot/ki-plattform" element={<KIPlattform />} />
            <Route path="/leistungsangebot/ki-mvp" element={<KIMVPDevelopment />} />
            <Route path="/leistungsangebot/ki-lab" element={<KILab />} />
            <Route path="/private-equity-ki-whitepaper" element={<PrivateEquityWhitepaper />} />
            <Route path="/ki-organisation-whitepaper" element={<KIOrganisationWhitepaper />} />
            <Route path="/partnerprogramm" element={<PartnerProgramm />} />
            
            {/* KI-Value-Engine */}
            <Route path="/ki-value-engine" element={<KIValueEngine />} />
            <Route path="/ki-value-check" element={<KIValueCheck />} />
            <Route path="/value-dashboard" element={<ValueDashboard />} />
            <Route path="/souveraene-cloud" element={<SouveraneCloud />} />
            
            {/* AIWizz Platform */}
            <Route path="/aiwizz-plattform" element={<AIWizzPlatform />} />
            
            {/* Solutions */}
            <Route path="/roi-business-impact" element={<ROIBusinessImpact />} />
            <Route path="/ai-driven-enterprise" element={<AIDrivenEnterprise />} />
            <Route path="/private-equity" element={<PrivateEquity />} />
            
            {/* Legacy redirects for old URLs */}
            <Route path="/leistungsangebot/ki-beratung" element={<Navigate to="/leistungsangebot/ki-akademie" replace />} />
            <Route path="/ki-plattform" element={<Navigate to="/aiwizz-plattform" replace />} />
            
            {/* English URL Redirects - redirect to German canonical URLs */}
            <Route path="/en" element={<Navigate to="/" replace />} />
            <Route path="/services" element={<Navigate to="/leistungsangebot" replace />} />
            <Route path="/services/ai-coaching" element={<Navigate to="/leistungsangebot/ki-coaching" replace />} />
            <Route path="/services/ai-academy" element={<Navigate to="/leistungsangebot/ki-akademie" replace />} />
            <Route path="/services/ai-transformation" element={<Navigate to="/leistungsangebot/ki-transformation" replace />} />
            <Route path="/services/ai-workshops" element={<Navigate to="/leistungsangebot/ki-workshops" replace />} />
            <Route path="/services/ai-applications" element={<Navigate to="/leistungsangebot/ki-anwendungen" replace />} />
            <Route path="/services/ai-platform" element={<Navigate to="/leistungsangebot/ki-plattform" replace />} />
            <Route path="/services/ai-mvp" element={<Navigate to="/leistungsangebot/ki-mvp" replace />} />
            <Route path="/services/ai-lab" element={<Navigate to="/leistungsangebot/ki-lab" replace />} />
            <Route path="/about-us" element={<Navigate to="/ueber-uns" replace />} />
            <Route path="/knowledge-center" element={<Navigate to="/wissenscenter" replace />} />
            <Route path="/ai-use-cases" element={<Navigate to="/ki-fallstudien" replace />} />
            <Route path="/our-spin-offs" element={<Navigate to="/spin-offs" replace />} />
            <Route path="/partner-program" element={<Navigate to="/partnerprogramm" replace />} />
            <Route path="/ai-value-engine" element={<Navigate to="/ki-value-engine" replace />} />
            <Route path="/ai-value-check" element={<Navigate to="/ki-value-check" replace />} />
            <Route path="/sovereign-cloud" element={<Navigate to="/souveraene-cloud" replace />} />
            <Route path="/aiwizz-platform" element={<Navigate to="/aiwizz-plattform" replace />} />
            
            {/* Navigation Pillar Redirects */}
            <Route path="/loesungen" element={<Navigate to="/roi-business-impact" replace />} />
            <Route path="/solutions" element={<Navigate to="/roi-business-impact" replace />} />
            <Route path="/enablement" element={<Navigate to="/leistungsangebot/ki-akademie" replace />} />
            <Route path="/expertise" element={<Navigate to="/wissenscenter" replace />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <Toaster />
          <CookieConsentManager />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;